// 공용 **오른쪽 서랍**(2026-09-27 첫 화면 개편 — 사용자 결정 "≡ → 오른쪽에서 미끄러져 나오는 메뉴").
// 바깥(어두운 막)을 누르거나 Esc 로 닫는다. 열려 있는 동안 서랍 안에 포커스를 둔다(키보드 사용자가 뒤 화면으로 새지 않게).
import { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';

export function Drawer({
  open,
  onClose,
  title,
  children,
}: {
  open: boolean;
  onClose: () => void;
  /** 서랍 머리 제목(스크린리더 이름 겸). */
  title: string;
  children: ReactNode;
}) {
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    panelRef.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return (
    <div className={`drawer-root${open ? ' open' : ''}`} aria-hidden={!open}>
      <div className="drawer-scrim" onClick={onClose} />
      <div ref={panelRef} className="drawer-panel" role="dialog" aria-modal="true" aria-label={title} tabIndex={-1}>
        <div className="drawer-top">
          <span className="drawer-title">{title}</span>
          <button className="modal-x" aria-label="닫기" onClick={onClose}>
            ✕
          </button>
        </div>
        {/* 닫힌 동안은 내용을 그리지 않는다 — 포커스·탭 이동이 보이지 않는 서랍으로 새지 않게. */}
        {open && <div className="drawer-body">{children}</div>}
      </div>
    </div>
  );
}
